import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';

// Services
import { ExperienceEditService } from '../../service/experience-edit/experience-edit.service';

@Component({
	selector: 'app-experience-edit',
	templateUrl: './experience-edit.component.html',
	providers: [
		ExperienceEditService,
		HttpModule
	]
})
export class ExperienceEditComponent implements OnInit {

	private token;
	private sub: any;
	public permissoes: any[] = [];
	experience: FormGroup;
	ID: string;
	Descricao: string;
	Ativo: boolean;

	constructor(fb: FormBuilder, private experienceEditService: ExperienceEditService, private flashMessagesService: FlashMessagesService, private router: Router, private route: ActivatedRoute) {
		this.token = localStorage.getItem('yara.token');
		this.experience = fb.group({
			'ID': '',
			'Descricao': ['', Validators.compose([Validators.required, Validators.maxLength(120)])],
			'Ativo': ''
		});
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
		this.sub = this.route.params.subscribe(params => {
			this.ID = params['guid'];
			this.experienceEditService.loadExperience(this.token, this.ID).subscribe(result => {
				console.log(result.Result);
				var updateExperience = result.Result;
				this.experience.setValue({
					ID: updateExperience.ID,
					Descricao: updateExperience.Descricao,
					Ativo: updateExperience.Ativo
				});
			})
		}, error => {
			console.log(error);
			
		});
	}

	editExperience(value: any) {
		this.experienceEditService.editExperience(this.token, value).subscribe(result => {
			if (result.Success) {
				this.flashMessagesService.show('Experiência editada com sucesso', { cssClass: 'alert-success', timeout: 6000 });
				this.router.navigateByUrl('/experiencia');
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
			
		});
	}

	cancelInsertEdit() {
		this.router.navigateByUrl('/experiencia');
	}

}



// WEBPACK FOOTER //
// ./src/app/experience/component/experience-edit/experience-edit.component.ts